// Sales, vzorové rozvrhy trenérů jen ke čtení (20. 10. 2026, Láďa): kde má kdo volno
// a kdo je plný, ať sales ví, co může nabídnout. Úpravy rozvrhu dělá vedení.
import React, { useMemo } from "react";
import { Eye, CalendarRange } from "lucide-react";
import GradientHeader from "../../components/GradientHeader.jsx";
import RozvrhVzorPrehled from "../../components/RozvrhVzorPrehled.jsx";
import RozvrhVzor from "../trener/RozvrhVzor.jsx";
import { useStickyTrener } from "../manager/TrenerRozvrh.jsx";
import { useApiData } from "../../lib/api.js";
import { Oznameni } from "../../components/sales/salesUi.jsx";

export default function SalesRozvrhy() {
  // Seznam trenérů ze souhrnu vzorů (seznam lidí z HR sales nevidí).
  const { data } = useApiData("/api/trener-rozvrh-pattern?souhrn=1");
  const trainers = useMemo(() => ((data && data.treneri) || []).map((t) => t.jmeno).filter(Boolean).sort((a, b) => a.localeCompare(b, "cs")), [data]);
  const [trener, setTrener] = useStickyTrener(trainers);
  return (
    <div className="space-y-4">
      <GradientHeader title="Rozvrhy trenérů" icon={CalendarRange} subtitle="Kde má kdo volno a kdo je plný" />
      <Oznameni ton="info" ikona={Eye}><b>Jen náhled.</b> Vidíš obsazenost a volné časy trenérů. Rozvrh upravuje vedení.</Oznameni>
      <RozvrhVzorPrehled trainers={trainers} value={trener} onChange={setTrener} />
      {trener && <RozvrhVzor trenerProp={trener} bezHlavicky jenCteni />}
    </div>
  );
}
